import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

// Catálogo público
export const getCategories = () =>
  api.get('/api/catalog/categories').then((r) => r.data);

export const getProducts = (category) =>
  api
    .get('/api/catalog/products', { params: category ? { category } : {} })
    .then((r) => r.data);

export const postContact = (payload) =>
  api.post('/api/contacts', payload).then((r) => r.data);

// Autenticação
export const login = (email, password) =>
  api.post('/api/auth/login', { email, password }).then((r) => r.data);

export const logout = () => api.post('/api/auth/logout').then((r) => r.data);

export const getMe = () => api.get('/api/auth/me').then((r) => r.data);

// Admin (protegido)
export const getContacts = () => api.get('/api/contacts').then((r) => r.data);

export const deleteContact = (id) =>
  api.delete(`/api/admin/contacts/${id}`).then((r) => r.data);

export const createProduct = (payload) =>
  api.post('/api/admin/products', payload).then((r) => r.data);

export const updateProduct = (id, payload) =>
  api.put(`/api/admin/products/${id}`, payload).then((r) => r.data);

export const deleteProduct = (id) =>
  api.delete(`/api/admin/products/${id}`).then((r) => r.data);

export default api;
